export const LOYALTY_TYPES = {
  available: 'available',
  availableMobile: 'availableMobile',
  earn: 'earn',
  applied: 'applied',
  availableWithButton: 'availableWithButton',
  withExpirationDate: 'withExpirationDate',
  profileDesktop: 'profileDesktop',
  profilePoints: 'profilePoints',
  availableMobileSearch: 'availableMobileSearch',
  profilePointsHistory: 'profilePointsHistory',
  joinVoyagersMessage: 'joinVoyagersMessage',
  savePointsRadioButton: 'savePointsRadioButton'
};
